import React from 'react';
import useNotificationStore from '../store/useNotificationStore';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle, FiAlertCircle, FiInfo, FiX } = FiIcons;

const ToastContainer = () => {
  const { notifications, removeNotification } = useNotificationStore();

  if (notifications.length === 0) return null;

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-[200] flex flex-col gap-2 pointer-events-none w-full max-w-md px-4">
      {notifications.map((note) => (
        <div 
          key={note.id}
          className={`pointer-events-auto flex items-center gap-3 px-4 py-3 rounded-lg shadow-xl border animate-in slide-in-from-top-2 fade-in duration-300 ${
            note.type === 'success' ? "bg-white border-green-200 text-gray-800" :
            note.type === 'error' ? "bg-white border-red-200 text-gray-800" :
            "bg-white border-blue-200 text-gray-800"
          }`}
        >
          {note.type === 'success' && <SafeIcon icon={FiCheckCircle} className="text-green-500 text-xl flex-shrink-0" />}
          {note.type === 'error' && <SafeIcon icon={FiAlertCircle} className="text-red-500 text-xl flex-shrink-0" />}
          {note.type === 'info' && <SafeIcon icon={FiInfo} className="text-blue-500 text-xl flex-shrink-0" />}
          
          <p className="text-sm font-medium flex-1">{note.message}</p>
          
          <button 
            onClick={() => removeNotification(note.id)}
            className="text-gray-400 hover:text-gray-600 transition-colors p-1"
          >
            <SafeIcon icon={FiX} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;